import MembershipPage from './membershipPage';
import OrganizationMembershipPage from './organization';
import useOrganization from '../../hooks/use-organization';

function MembershipIndex() {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? (
    <OrganizationMembershipPage />
  ) : (
    <MembershipPage />
  );
}

export default MembershipIndex;
